import type { Resource } from '../../';
export const cart_couponCodes_rejection_notActive: Resource = {"default":"The requested coupon is not active at the moment."};
